export const b2bApi = {
  GET_B2B_PROFILE: '/api/b2b/profile',
  UPDATE_B2B_PROFILE: '/api/b2b/profile',

  /* b2b invoices--------------------- */
  B2B_INVOICE_LIST: '/api/b2b/invoice',

  /* ---------slot Create-------------------- */
  B2B_SLOTS_CREATE: '/api/common/meeting-slot',
  BOOKING_SLOT_REQUEST: '/api/common/meeting-slot/request',
  OTHER_COMPANY_SLOT_REQUEST_LIST: '/api/common/meeting-slot/request',
  SLOT_REQUEST_STATUS_UPDATE: '/api/common/meeting-slot/request',
  GET_MY_MEETING_SLOT_REQUEST: '/api/common/meeting-slot/my-request',
  GET_ALL_OWN_SLOTS: '/api/common/meeting-slot',
  GET_ALL_AVAILABLE_SLOTS: '/api/common/meeting-slot/available-company',
  GET_SPECIFIC_USER_AVAILABLE_SLOTS: '/api/common/meeting-slot/user',

  /* reserved slot */
  RESERVED_SLOT: '/api/common/meeting-slot',
};
